import EventBus from 'diagram-js/lib/core/EventBus';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {constants} from '@ispm-client/modules/bpmn-modeler/constants/constants';
import {exclusiveGatewayType, processType} from '../../../../../../ispm-web/shared/modules/bpmn/index';
import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import Modeling from 'diagram-js/lib/features/modeling/Modeling';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import {NodeType} from "@ispm/shared/bpmn-io/node-type";
import {PathwaysModeling} from "@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling";
import {TreeNavigator} from "@ispm/shared/bpmn-io/services/tree-navigator";

export class FloatingNodesConnectionEndBehaviour {

  constructor(protected eventBus: EventBus, protected modeling: Modeling, protected elementFactory, protected autoPlace, private pathwaysModeling: PathwaysModeling, private treeNavigator: TreeNavigator, private elementRegistry) {

    this.eventBus.on([
      EventType.CONNECT_END,
    ], 100000, this.interceptConnectFloatingNodes.bind(this));
  }

  interceptConnectFloatingNodes(event) {

    let context = event.context,
      source = context.source,
      sourcePosition = context.sourcePosition,
      target = context.target,
      targetPosition = {
        x: event.x,
        y: event.y
      },
      attrs = null,
      hints = {
        connectionStart: sourcePosition,
        connectionEnd: targetPosition
      };
    const originalSource = context.source;
    let gateway;

    // 1. never connecting between gateways
    // 2. never connecting between node with children to treatment plan node
    // 3. never connecting to gateways
    // 4. never connect to non shape

    if (!target ||
      !ModelingUtil.isOnTheSameTreeLayer(source, target) ||
      (ModelingUtil.getNodeOutGoingGateway(source) && ModelingUtil.getNodeIncomingGateway(target)) ||
      (ModelingUtil.hasChildren(source) && ModelingUtil.isTreatmentNode(target) && !ModelingUtil.AllOutgoingConnectionWithDeletedTrackingChange(source)) ||
      ModelingUtil.isGateway(target) ||
      ModelingUtil.hasLoopBetweenNodes(source, target) ||
      ModelingUtil.hasDeletionTrackingChange(target)) {
      return true;
    }
    const sourceHasOutgoingGateway = ModelingUtil.getNodeOutGoingGateway(source);
    const targetHasIncomingGateway = ModelingUtil.getNodeIncomingGateway(target);
    const gatewayParentsNodes = sourceHasOutgoingGateway && ModelingUtil.getParentGateways(sourceHasOutgoingGateway);


    if (source.id !== target.id && !ModelingUtil.isHeadNode(target) && !ModelingUtil.isNeighborhoodHeadNode(target) && ModelingUtil.getElementType(target) !== processType) {

      if (!sourceHasOutgoingGateway) {
        // connecting to treatment plan node without gateway
        if (ModelingUtil.getNodeType(target) === NodeType.treatment) {
          this.modelingConnect(source, target, attrs, hints)
          this.pathwaysModeling.appendNewConnection(source, target, originalSource);
          return true;
        } else {
          // target is not treatment plan , check if target has gateway
          if (!targetHasIncomingGateway) {

            const gatewayShape = this.elementFactory.createShape({
              type: exclusiveGatewayType, width: constants.EXCLUSIVE_GATEWAY_DIMENSIONS.width,
              height: constants.EXCLUSIVE_GATEWAY_DIMENSIONS.height
            }, {});
            gatewayShape.businessObject.neighborhoodID = this.treeNavigator.currentLayer;

            const newGateway = this.autoPlace.append(source, gatewayShape);
            this.pathwaysModeling.appendNewConnection(source, newGateway, originalSource);
            target = context.target;
            this.modelingConnect(newGateway, target, attrs, hints);
            // get the updated source after connecting it to gateway
            const updatedSource = this.elementRegistry.get(originalSource.id);
            this.pathwaysModeling.appendNewConnection(newGateway, target, updatedSource);
            return true;
          } else {
            // target has connected gateway , source -> gateway -> target
            gateway = targetHasIncomingGateway;
            target = ModelingUtil.getDirectTreeChildrenNodes(gateway);
            hints.connectionEnd = {
              x: gateway.x + Math.round(gateway.width / 2),
              y: gateway.y + Math.round(gateway.width / 2)
            };
            this.modelingConnect(source, gateway, attrs, hints);
            this.pathwaysModeling.appendNewConnection(source, target, originalSource, gateway);

            return true;
          }
        }
      } else {
        // source has gateway, path: source -> gateway -> target
        source = sourceHasOutgoingGateway;
        if (sourceHasOutgoingGateway.outgoing.length > 0) {
          // if its not floated gateway
          hints.connectionStart = {
            x: source.x + Math.round(source.width / 2),
            y: source.y + Math.round(source.width / 2)
          };
        } else {
          hints.connectionStart = {
            x: source.x - Math.round(source.width / 2),
            y: source.y + Math.round(source.width / 2)
          };
        }

        this.modelingConnect(source, target, attrs, hints);

        for(const node of gatewayParentsNodes) {
            this.pathwaysModeling.appendNewConnection(source, target, node);
        }
        return true;
      }

    }
  }

  private modelingConnect(source, target, attrs, hints) {
    const connection = ModelingUtil.getConnectionWithDeletionTrackingChange(source, target);
    if (connection) {
      this.pathwaysModeling.removeElements([connection]);
    }

    this.modeling.connect(source, target, attrs, hints);
  }
}

FloatingNodesConnectionEndBehaviour.$inject = [...CommandInterceptor.$inject, 'modeling', 'elementFactory', 'autoPlace', 'pathwaysModeling', 'treeNavigator', 'elementRegistry'];
